import script from "./managementTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./managementTeam.vue?vue&type=script&setup=true&lang=js"

import "./managementTeam.vue?vue&type=style&index=0&id=d1c3e1fa&lang=less&scoped=true"

import exportComponent from "D:\\Develop\\项目\\机电集团官网\\custom-website-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1c3e1fa"]])

export default __exports__